import { render } from "./studios-block.vue?vue&type=template&id=1b7cd88e&scoped=true"
import script from "./studios-block.vue?vue&type=script&lang=js"
export * from "./studios-block.vue?vue&type=script&lang=js"

import "./studios-block.vue?vue&type=style&index=0&id=1b7cd88e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7cd88e"]])

export default __exports__